import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { hiddenContentClassName } from "@1js/acui-common";
import { useButtonStyles_unstable } from "@fluentui/react-components";

import type { AppGalleryButtonState } from "./AppGalleryButton.type";
// eslint-disable-next-line no-restricted-imports
import {
  hiddenContentStyle,
  useCommonDisabledStyles,
} from "@1js/acui-common/lib/styling/next";
import { customTokens } from "@1js/acui-theme";

const useRootStyles = makeStyles({
  root: {
    [`& .${hiddenContentClassName}`]: {
      ...hiddenContentStyle,
    },
    padding: `0px ${customTokens.spacingHorizontalXS}`,
    minWidth: "unset",
    fontSize: customTokens.fontSizeBase200,
    fontWeight: customTokens.fontWeightRegular,
    lineHeight: customTokens.lineHeightBase200,
  },
});

const useSizeStyles = makeStyles({
  // gallery button can't be small
  medium: {
    height: "22px",
    margin: customTokens.spacingHorizontalXS,
  },
  large: {
    height: "40px",
    margin: "11px",
  },
  icon: {
    height: "30px",
    width: "30px",
    marginRight: "0px",
  },
});

export const useAppGalleryButtonStyles = (
  state: AppGalleryButtonState
): AppGalleryButtonState => {
  const rootStyles = useRootStyles();
  const sizeStyles = useSizeStyles();
  const disabledStyles = useCommonDisabledStyles();

  state.root.className = mergeClasses(
    "ms-ButtonNext",
    "ms-Button",
    rootStyles.root,
    state.size === "large" ? sizeStyles.large : sizeStyles.medium,
    (state.disabled || state.disabledFocusable) && disabledStyles.base,
    state.root.className
  );
  if (state.icon) state.icon.className = mergeClasses(sizeStyles.icon);
  useButtonStyles_unstable(state);

  return state;
};
